var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  text-align: center;\n  margin-bottom: 1rem;\n  justify-content: center;\n  flex-direction: column-reverse;\n  button {\n    min-width: 250px;\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n'], ['\n  display: flex;\n  text-align: center;\n  margin-bottom: 1rem;\n  justify-content: center;\n  flex-direction: column-reverse;\n  button {\n    min-width: 250px;\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  flex: 1 1 0;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  flex: 1 1 0;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  justify-content: center;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  flex: 1 1 0;\n  margin-bottom: 16px;\n  @media (max-width: 768px) {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n'], ['\n  justify-content: center;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  flex: 1 1 0;\n  margin-bottom: 16px;\n  @media (max-width: 768px) {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Fragment } from 'react';
import styled from 'styled-components';
import ColourButton, { TransparentButton } from '../Button';
import { isEmpty, isNil, omit } from 'ramda';
var PageButtonsContainer = styled.div(_templateObject);
var Left = styled.div(_templateObject2);
var Right = styled.div(_templateObject3);

var PageButtons = function PageButtons(props) {
  var colour = props.colour || 'primary';
  var buttonLabel = props.label || 'Next';
  var backText = props.backText || 'or go back';
  var hasIcon = !isNil(props.icon) && !isEmpty(props.icon);
  var newProps = omit(['icon'], props);
  return React.createElement(Fragment, null, !hasIcon && React.createElement(PageButtonsContainer, null, React.createElement(Left, null, React.createElement('a', {
    onClick: function onClick() {
      return props.backAction();
    }
  }, backText)), React.createElement(Right, null, React.createElement(ColourButton, _extends({
    colour: colour
  }, props), buttonLabel))), hasIcon && React.createElement(PageButtonsContainer, null, React.createElement(Left, null, React.createElement(TransparentButton, {
    icon: 'leftArrow',
    onClick: function onClick() {
      return props.backAction();
    }
  })), React.createElement(Right, null, React.createElement(ColourButton, _extends({
    colour: colour
  }, newProps), buttonLabel))));
};

export default PageButtons;